import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ImmomioIconName, TicketCardBaseComponent } from '@resident-nx/shared';

import { DatePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CardWebComponent, IconWebComponent } from '@resident-nx/web/ui';
import { ImmomioAnchorComponent } from '@immomio/ui/button';
import { StatusBadgeWebComponent } from '../../../atoms/status-badge/status-badge.component';
import { LabelWebComponent } from '../../../atoms/label/label.component';

@Component({
  standalone: true,
  selector: 'rs-web-ticket-card',
  imports: [
    CardWebComponent,
    StatusBadgeWebComponent,
    LabelWebComponent,
    IconWebComponent,
    ImmomioAnchorComponent,
    DatePipe,
    TranslateModule,
  ],
  templateUrl: './ticket-card.component.html',
  styleUrl: './ticket-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TicketCardWebComponent extends TicketCardBaseComponent {
  protected readonly immomioIconName = ImmomioIconName;
}
